import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from '../Logo';
import type { SlideProps } from './SlideShell';
export function Slide17Closing({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-white" data-id="element-359">
      {/* Hero image with pharmaceutical overlay */}
      <div className="absolute inset-0" data-id="element-360">
        <motion.img src="https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=1920&q=80" alt="Pharmaceutical capsules" className="w-full h-full object-cover opacity-20 mix-blend-multiply" initial={{
        scale: 1.05
      }} animate={{
        scale: 1
      }} transition={{
        duration: 10,
        ease: 'easeOut'
      }} data-id="element-361" />
        <div className="absolute inset-0 bg-gradient-to-t from-white via-white/90 to-white/60" data-id="element-362" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-[clamp(2rem,6vw,6rem)] text-center" data-id="element-363">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="mb-8" data-id="element-364">
          <div className="w-24 h-24 rounded-full bg-[var(--surface)] border-4 border-white shadow-xl flex items-center justify-center mx-auto mb-6" data-id="element-365">
            <svg className="w-12 h-12 text-[var(--brand)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-366">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" data-id="element-367" />
            </svg>
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="text-[var(--fg)] font-bold text-[clamp(2rem,4vw,3.5rem)] leading-[1.1] tracking-tight max-w-4xl mb-6" data-id="element-368">
          A scalable model for making Amoxil digital engagement feel active
          again
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.55,
        duration: 0.6
      }} className="text-[var(--muted)] text-[clamp(1.1rem,1.5vw,1.4rem)] font-medium max-w-3xl leading-relaxed mb-12" data-id="element-369">
          Snakker gives GSK Morocco a practical way to turn Amoxil's monthly
          digital campaigns into interactive HCP experiences. The recommended
          12-month model creates the strongest balance between quality,
          efficiency, data, and continuous optimization.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.7,
        duration: 0.6
      }} className="bg-[var(--brand)] text-white px-8 py-4 rounded-full shadow-lg font-bold text-lg inline-flex items-center gap-3" data-id="element-370">
          <span className="uppercase tracking-wider text-sm text-white/80" data-id="element-371">
            Recommended option:
          </span>
          12-month annual engagement model
        </motion.div>
      </div>

      {/* Co-brand footer row */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 0.6
    }} className="absolute bottom-[clamp(1.5rem,3vh,2.5rem)] left-[clamp(2rem,6vw,6rem)] right-[clamp(2rem,6vw,6rem)] z-10 flex items-center justify-between gap-4" data-id="element-372">
        <Logo width={100} data-id="element-373" />
        <div className="flex items-center gap-3" data-id="element-374">
          <span className="px-3 py-1 bg-[var(--brand)] text-white text-xs font-bold rounded-full uppercase tracking-wider" data-id="element-375">
            GSK Morocco
          </span>
          <span className="px-3 py-1 bg-white border border-black/10 text-[var(--fg)] text-xs font-bold rounded-full uppercase tracking-wider" data-id="element-376">
            Amoxil
          </span>
        </div>
      </motion.div>
    </div>;
}